import { React, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../assets/custom_styles.css";
const CMSPagesComponent = () => {
  const [pageData, setPageData] = useState({});
  const [error, setError] = useState("");
  const { page_shortname } = useParams();

  useEffect(() => {
    axios
      .post("Fetch_CmsDetails", { page_shortname })
      .then((response) => {
        const result = response.data;
        if (result.code === 200 && result.data?.length > 0) {
          setPageData(result.data[0]);
        }
      })
      .catch((error) => {
        setError("Page not found");
      });
  }, [page_shortname]);
  if (error) return <div>{error}</div>;
  return (
    <div>
      <div
        className=" container cms-wrapper"
        dangerouslySetInnerHTML={{ __html: pageData.cms_content }}
      />
    </div>
  );
};

export default CMSPagesComponent;
